import './alert.css';
export default {
  "alert": "pf-v6-c-alert",
  "alertAction": "pf-v6-c-alert__action",
  "alertActionGroup": "pf-v6-c-alert__action-group",
  "alertDescription": "pf-v6-c-alert__description",
  "alertIcon": "pf-v6-c-alert__icon",
  "alertTitle": "pf-v6-c-alert__title",
  "alertToggle": "pf-v6-c-alert__toggle",
  "alertToggleIcon": "pf-v6-c-alert__toggle-icon",
  "button": "pf-v6-c-button",
  "dirRtl": "pf-v6-m-dir-rtl",
  "modifiers": {
    "custom": "pf-m-custom",
    "success": "pf-m-success",
    "danger": "pf-m-danger",
    "warning": "pf-m-warning",
    "info": "pf-m-info",
    "inline": "pf-m-inline",
    "plain": "pf-m-plain",
    "expandable": "pf-m-expandable",
    "expanded": "pf-m-expanded",
    "truncate": "pf-m-truncate"
  }
};